'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _en_US = require('../../date-picker/locale/en_US');

var _en_US2 = _interopRequireDefault(_en_US);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _en_US2['default'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/calendar/locale/en_US.js
// module id = 680
// module chunks = 0